
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"44","height":"44"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#fff","stroke":"#494949","stroke-width":"1.5"}},[_c('path',{attrs:{"d":"M16 28.5a5 5 0 015-5h2a5 5 0 015 5v.75a4 4 0 01-4 4h-4a4 4 0 01-4-4v-.75z"}}),_c('path',{attrs:{"d":"M26 27.5a6 6 0 016-6h4a6 6 0 016 6v3a4 4 0 01-4 4h-8a4 4 0 01-4-4v-3zm-24 0a6 6 0 016-6h4a6 6 0 016 6v3a4 4 0 01-4 4H6a4 4 0 01-4-4v-3z"}})]),_c('g',{attrs:{"fill-rule":"evenodd","stroke":"#363636","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"fill":"#24A4EC","d":"M24.449 14.879a3 3 0 11-4.243 4.242 3 3 0 014.243-4.242z"}}),_c('path',{attrs:{"fill":"#F9B621","d":"M37.304 9.369a4.673 4.673 0 11-6.608 6.607 4.673 4.673 0 016.608-6.607zm-24 0a4.673 4.673 0 11-6.608 6.607 4.673 4.673 0 016.608-6.607z"}})])])
          )
        }
      }
    